import React, { useContext, useState, useMemo, useEffect, useRef } from 'react';
import NewsSingleCategory from '../NewsSingleCategory/NewsSingleCategory';
import T, { t } from '../../../../../common/components/T';
import { LangContext } from '../../../../../common/decorators/Language';
import css from './NewsCategoriesWrapper.module.scss';
import classnames from 'classnames';
import { getData } from '../../../../../common/utils/router';
import UserContext from '../../../../../common/utils/getContext';
import { svgSprite } from '../../../../../hybrid/wrappers';

const NewsCategoriesWrapper = ({ categories, currentId, changeTableItemsLength, sorter }) => {
    const { translation } = useContext(LangContext) || {};
    const { userToken, lang } = useContext(UserContext) || {};
    const [nextLink, setNextLink] = useState(categories?.links?.next);
    const [categoriesData, setCategoriesData] = useState(categories?.data);
    useEffect(() => {
        setCategoriesData(categories?.data);
        setNextLink(categories?.links?.next);
    }, [categories]);
    let transformedCategories = useMemo(() => {
        return [
            {
                depth: 1,
                parent_id: null,
                title: t('allVariants', 'Все', 'all', translation),
                position: -1
            },
            ...(Array.isArray(categoriesData) ? categoriesData : [])
        ]
            .filter((el) => !el.parent_id && el.depth === 1)
            .sort((a, b) => a.position - b.position);
    }, [categoriesData, translation]);

    const headRef = useRef();
    const categoriesListRef = useRef();
    const scrollLeftBtnRef = useRef();
    const [scrollRightBtn, showScrollRightBtn] = useState(false);
    const [scrollLeftBtn, showScrollLeftBtn] = useState(false);

    useEffect(() => {
        if (headRef.current) {
            if (headRef.current.scrollWidth - headRef.current.clientWidth > 0) {
                showScrollRightBtn(true);
            } else {
                showScrollRightBtn(false);
            }
        }
    }, [headRef.current]);

    useEffect(() => {
        if (categoriesListRef.current && headRef.current) {
            const wrapper = headRef.current?.getBoundingClientRect();
            const inner = categoriesListRef.current?.getBoundingClientRect();
            const width = wrapper.width - inner.x;

            categoriesListRef.current.style.width = width + 48 + 'px';
        }
    }, [categoriesListRef.current, headRef.current]);

    const scrollFunc = (vector) => {
        switch (vector) {
            case 'right': {
                if (
                    categoriesListRef.current.scrollWidth - categoriesListRef.current.scrollLeft + 1 <=
                    categoriesListRef.current.clientWidth
                ) {
                    showScrollRightBtn(false);
                }
                categoriesListRef.current.scrollBy({ left: 120, behavior: 'smooth' });
                showScrollLeftBtn(true);
                break;
            }
            case 'left': {
                if (categoriesListRef.current.scrollLeft - 120 <= 0) {
                    showScrollLeftBtn(false);
                }
                showScrollRightBtn(true);
                categoriesListRef.current.scrollBy({ left: -120, behavior: 'smooth' });
                break;
            }
        }
    };

    useEffect(() => {
        if (scrollLeftBtn && scrollLeftBtnRef.current && categoriesListRef.current) {
            scrollLeftBtnRef.current.style.left = categoriesListRef.current.getBoundingClientRect().left - 100 + 'px';
        }
    }, [scrollLeftBtn, scrollLeftBtnRef.current, categoriesListRef.current]);

    return (
        <div ref={headRef} className={classnames('scrollbar-hidden', css.newsHeader)} style={{ overflowX: 'scroll' }}>
            {scrollRightBtn ? (
                <div onClick={() => scrollFunc('right')} className={classnames('circleButtonSmall', css.scrollBtn)}>
                    {svgSprite('angle-right')}
                </div>
            ) : null}
            {scrollLeftBtn ? (
                <div
                    ref={scrollLeftBtnRef}
                    onClick={() => scrollFunc('left')}
                    className={classnames('circleButtonSmall', css.scrollBtnLeft)}
                >
                    {svgSprite('angle-left')}
                </div>
            ) : null}
            <div className={css.newsSorter}>
                <p className={classnames(css.newsSorterLabel)}>
                    <T textName='firstly-show' defaultStr='Показывать сначала' page='/news' />:
                </p>
                <p
                    onClick={() => changeTableItemsLength({ value: 0 })}
                    className={classnames(css.newsSorterFilter, sorter === 0 && css.newsSorterFilterActive)}
                >
                    <T textName='new-many' defaultStr='Новые' page='/news' />
                </p>
                <p
                    onClick={() => changeTableItemsLength({ value: 1 })}
                    className={classnames(css.newsSorterFilter, sorter === 1 && css.newsSorterFilterActive)}
                >
                    <T textName='old-many' defaultStr='Старые' page='/news' />
                </p>
            </div>
            <div className={classnames(css.newsCategoriesWrapper)}>
                <p className={css.newsCategoriesLabel}>
                    <T textName='categories' defaultStr='Категории' page='/news' />:
                </p>
                <div ref={categoriesListRef} className={css.onlyCategoriesWrapper}>
                    {transformedCategories.map((el, ind) => {
                        return <NewsSingleCategory key={`NewsSingleCategory_${ind}`} currentId={currentId} category={el} />;
                    })}
                </div>
                {nextLink ? (
                    <NewsSingleCategory
                        onClick={() => {
                            getData(nextLink, userToken, lang).then((newData) => {
                                setCategoriesData((pre) => [...pre, ...newData?.data]);
                                setNextLink(newData?.links?.next);
                            });
                        }}
                        currentId={false}
                        category={{ title: '...' }}
                    />
                ) : null}
            </div>
        </div>
    );
};
export default NewsCategoriesWrapper;
